import {
  Box,
  Button,
  circularProgressClasses,
  LinearProgress,
  Typography,
} from "@mui/material";
import { useEffect } from "react";
import { useIncludedFeatureJob } from "../../contexts/hooks/useIncludedFeatureJob";
import CircularProgressWithLabel from "./CircularProgressWithLabel";
import { usePreload } from "../../contexts/DataContext/PreloadContext";

function ImportButton({ text, sx, startImport, onRunningChange, isRunning }) {
  console.log(`isRunning`, isRunning);
  const { confirmDialog } = usePreload();
  return (
    <Button
      onClick={async () => {
        const ok = await confirmDialog.show({
          title: "Import Job",
          message: `Do you want this feature to be included in all classes?`,
        });

        if (!ok) {
          confirmDialog.close();
          return;
        }

        confirmDialog.close();
        startImport();
      }}
      disabled={false}
      size="small"
      sx={sx}
    >
      {isRunning ? "Starting..." : text}
    </Button>
  );
}

export default ImportButton;
